import Dto from "../../../../../lib/model/service/Dto";

class ReadCampaignCloneInfo extends Dto {

  campaignId;

  constructor(campaignId = '') {
    super('appl\\service\\campaign\\dto\\ReadCampaignCloneInfo');
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

}

export default ReadCampaignCloneInfo;
